import Component from '@glimmer/component';

import { array } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import string from 'rise-ui/helpers/string.js';

export default class CatalogDetailAssociatedItemsComponent extends Component {
  <template>
    <div class="c-related-links__section">
      <h4 class="c-section-title">
        {{string "record-items-heading"}}
      </h4>
      <div>
        {{#each @record.groupedItems.ordered as | groupedItems |}}
          <ExpandingBlock @initExpanded={{true}} @button={{true}}>
            <:head>
              <span class="c-related-links__title">{{groupedItems.type}}</span>
            </:head>
            <:body>
              <div class="c-related-links__links">
                {{#each groupedItems.items as | item |}}
                  <div class="c-related-links__link">
                    <span class="id-catalog-record__item-type">{{item.type}}</span>
                    <LinksTo
                      @route="catalog.record.item"
                      @models={{array @record.id item.id}}
                    >
                      {{~item.title~}}
                    </LinksTo>
                  </div>
                {{/each}}
              </div>
            </:body>
          </ExpandingBlock>
        {{else}}
          <p class="id-catalog-record__no-items-hint qa-record-items-empty">
            {{string "record-no-items-hint"}}
          </p>
        {{/each}}
      </div>
    </div>
  </template>
}
